import { render } from "./RewardCatalogue.vue?vue&type=template&id=66a9f446&scoped=true"
import script from "./RewardCatalogue.vue?vue&type=script&lang=js"
export * from "./RewardCatalogue.vue?vue&type=script&lang=js"

import "./RewardCatalogue.vue?vue&type=style&index=0&id=66a9f446&scoped=true&lang=css"

import exportComponent from "/var/www/html/minty.crm.frontend.member/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66a9f446"]])

export default __exports__